import React from 'react'
import { useGLTF } from '@react-three/drei'
import TransitionMaterialFree from './MeshTransitionMaterialFree/MeshTransitionMaterialFree'

export default function Model({ transitionColor, ...props }) {
  const { nodes, materials } = useGLTF('/bike1.glb')
  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, -Math.PI]}>
          <group name="root">
            <group name="GLTF_SceneRootNode" rotation={[Math.PI / 2, 0, 0]}>
              <group
                name="Srad750001_3"
                position={[-0.001, 0.329, -0.753]}
                rotation={[1.555, 0, 0]}>
                <mesh
                  name="Object_38"
                  castShadow
                  geometry={nodes.Object_38.geometry}
                >
                  <TransitionMaterialFree
                    roughness={0.25}
                    transitionColor={transitionColor}
                    metalness={0.25}
                    transitionTime={0.4}
                    clearcoat={1}
                    clearcoatRoughness={0.05}
                  />
                </mesh>
                <mesh
                  name="Object_39"
                  geometry={nodes.Object_39.geometry}
                  material={materials.renan__spec}
                />
                <mesh
                  name="Object_40"
                  castShadow
                  geometry={nodes.Object_40.geometry}
                  material={materials.Roue}
                />
                <mesh
                  name="Object_41"
                  geometry={nodes.Object_41.geometry}
                  material={materials['Material.001']}
                />
              </group>
              <group name="Srad750002_4" position={[0, 0.52, -0.051]} rotation={[1.555, 0, 0]}>
                <mesh
                  name="Object_43"
                  geometry={nodes.Object_43.geometry}
                  material={materials['Material.005']}
                />
              </group>
              <group name="Srad750004_5" position={[0.015, 0.347, 0.847]} rotation={[1.555, 0, 0]}>
                <mesh
                  name="Object_45"
                  castShadow
                  geometry={nodes.Object_45.geometry}
                >
                  <TransitionMaterialFree
                    roughness={0.25}
                    transitionColor={transitionColor}
                    metalness={0.25}
                    transitionTime={0.4}
                    clearcoat={1}
                    clearcoatRoughness={0.05}
                  />
                </mesh>
                <mesh
                  name="Object_46"
                  geometry={nodes.Object_46.geometry}
                  material={materials.renan__spec}
                />
                <mesh
                  name="Object_47"
                  castShadow
                  geometry={nodes.Object_47.geometry}
                  material={materials.Roue}
                />
                <mesh
                  name="Object_48"
                  geometry={nodes.Object_48.geometry}
                  material={materials['Material.001']}
                />
              </group>
              <group name="Srad750006_6" position={[0, 0.52, -0.051]} rotation={[1.555, 0, 0]}>
                <mesh
                  name="Object_50"
                  castShadow
                  geometry={nodes.Object_50.geometry}
                >
                  <TransitionMaterialFree
                    roughness={0.25}
                    transitionColor={transitionColor}
                    metalness={0.25}
                    transitionTime={0.4}
                    clearcoat={1}
                    clearcoatRoughness={0.05}
                  />
                </mesh>
                <mesh
                  name="Object_51"
                  geometry={nodes.Object_51.geometry}
                  material={materials.renan__spec}
                />
                <mesh
                  name="Object_52"
                  geometry={nodes.Object_52.geometry}
                  material={materials.aluminium__spec}
                />
                <mesh
                  name="Object_53"
                  geometry={nodes.Object_53.geometry}
                  material={materials.Matte__FFCCCCCC__env_50}
                />
                <mesh
                  name="Object_54"
                  geometry={nodes.Object_54.geometry}
                  material={materials.branco__spec}
                />
                <mesh
                  name="Object_55"
                  geometry={nodes.Object_55.geometry}
                  material={materials.Matte__FFFFF2C6__spec}
                />
                <mesh
                  name="Object_56"
                  geometry={nodes.Object_56.geometry}
                  material={materials.Matte__FFAAAAAA__env_11_spec}
                />
                <mesh
                  name="Object_57"
                  geometry={nodes.Object_57.geometry}
                  material={materials.Matte__FF8C0000__spec}
                />
                <mesh
                  name="Object_58"
                  geometry={nodes.Object_58.geometry}
                  material={materials['Material.001']}
                />
              </group>
              <group name="Srad750_1" position={[0, 0.52, -0.051]} rotation={[1.555, 0, 0]}>
                <mesh
                  name="Object_10"
                  geometry={nodes.Object_10.geometry}
                  material={materials.Matte__FFFF3C00__spec_RR}
                />
                <mesh
                  name="Object_11"
                  geometry={nodes.Object_11.geometry}
                  // material={materials.Matte__FFFFFFFF}
                />
                <mesh
                  name="Object_12"
                  geometry={nodes.Object_12.geometry}
                  material={materials.Matte__FFCCCCCC}
                />
                <mesh
                  name="Object_13"
                  geometry={nodes.Object_13.geometry}
                  material={materials.aluminium__spec}
                />
                <mesh
                  name="Object_14"
                  geometry={nodes.Object_14.geometry}
                  material={materials.renan}
                />
                <mesh
                  name="Object_15"
                  geometry={nodes.Object_15.geometry}
                  material={materials.branco__spec}
                />
                <mesh
                  name="Object_16"
                  geometry={nodes.Object_16.geometry}
                  material={materials.fronts__spec}
                />
                <mesh
                  name="Object_17"
                  geometry={nodes.Object_17.geometry}
                  material={materials.Matte__FFCCCCCC__env_50}
                />
                <mesh
                  name="Object_18"
                  geometry={nodes.Object_18.geometry}
                  material={materials.branco__spec}
                />
                <mesh
                  name="Object_19"
                  geometry={nodes.Object_19.geometry}
                  material={materials.Matte__FFFF0000}
                />
                <mesh
                  name="Object_20"
                  geometry={nodes.Object_20.geometry}
                  material={materials.Matte__FF0000FF}
                />
                <mesh
                  name="Object_21"
                  geometry={nodes.Object_21.geometry}
                  material={materials.Matte__FFFFFF00}
                />
                <mesh
                  name="Object_22"
                  geometry={nodes.Object_22.geometry}
                  material={materials.Matte__FF00FF00}
                />
                <mesh
                  name="Object_23"
                  geometry={nodes.Object_23.geometry}
                  material={materials.Matte__FFFF6666}
                />
                <mesh
                  name="Object_24"
                  geometry={nodes.Object_24.geometry}
                >
                  <meshStandardMaterial
                    color="red"
                    emissive="white"
                    emissiveIntensity={5}
                    roughness={0.1}
                    metalness={0.1}
                  />
                </mesh>
                <mesh
                  name="Object_25"
                  geometry={nodes.Object_25.geometry}
                  material={materials.Matte__6BFFFFFF__prim_spec_trans}
                />
                <mesh
                  name="Object_255"
                  geometry={nodes.Object_255.geometry}
                >
                  <meshStandardMaterial
                    color="red"
                    emissive="white"
                    emissiveIntensity={3}
                    roughness={0.1}
                    metalness={0.1}
                  />
                </mesh>
                <mesh
                  name="Object_26"
                  geometry={nodes.Object_26.geometry}
                  material={materials.branco__spec}
                />
                <mesh
                  name="Object_27"
                  geometry={nodes.Object_27.geometry}
                  material={materials.Matte__662F2F2F__spec_trans}
                />
                <mesh
                  name="Object_28"
                  geometry={nodes.Object_28.geometry}
                  material={materials.Matte__FF292929}
                />
                <mesh
                  name="Object_29"
                  geometry={nodes.Object_29.geometry}
                  material={materials.Matte__FFB90000}
                />
                <mesh
                  name="Object_30"
                  geometry={nodes.Object_30.geometry}
                  material={materials.branco__spec}
                />
                <mesh
                  name="Object_31"
                  geometry={nodes.Object_31.geometry}
                  material={materials.Matte__FFFFF2C6__spec}
                />
                <mesh
                  name="Object_32"
                  castShadow
                  geometry={nodes.Object_32.geometry}
                  material={materials.Motor}
                />
                <mesh
                  name="Object_33"
                  geometry={nodes.Object_33.geometry}
                  material={materials.Echape}
                />
                <mesh
                  name="Object_34"
                  geometry={nodes.Object_34.geometry}
                  // material={materials['Material.004']}
                />
                <mesh
                  name="Object_35"
                  geometry={nodes.Object_35.geometry}
                  material={materials['Material.002']}
                />
                <mesh
                  name="Object_36"
                  geometry={nodes.Object_36.geometry}
                  material={materials['Material.003']}
                />
                <mesh
                  name="Object_4"
                  castShadow
                  geometry={nodes.Object_4.geometry}
                >
                  <TransitionMaterialFree
                    roughness={0.25}
                    transitionColor={transitionColor}
                    metalness={0.25}
                    transitionTime={0.4}
                    clearcoat={1}
                    clearcoatRoughness={0.05}
                  />
                </mesh>
                <mesh
                  name="Object_5"
                  castShadow
                  geometry={nodes.Object_5.geometry}
                >
                  <TransitionMaterialFree
                    roughness={0.25}
                    transitionColor={transitionColor}
                    metalness={0.25}
                    transitionTime={0.4}
                    clearcoat={1}
                    clearcoatRoughness={0.05}
                  />
                </mesh>
                <mesh
                  name="Object_6"
                  geometry={nodes.Object_6.geometry}
                  material={materials.renan__spec}
                />
                <mesh
                  name="Object_7"
                  geometry={nodes.Object_7.geometry}
                  material={materials.Matte__FF00FFC8__spec_FR}
                />
                <mesh
                  name="Object_8"
                  geometry={nodes.Object_8.geometry}
                  material={materials.Matte__FFCCCCCC__spec}
                />
                <mesh
                  name="Object_9"
                  geometry={nodes.Object_9.geometry}
                  material={materials.branco__spec}
                />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/bike1.glb')
